/*
 * @Author: huangzq
 * @Date: 2019-12-19 14:52:11
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-01-08 20:33:05
 * @Desc: 处理画布尺寸
*/
export default (currCanvas: { [key: string]: any }) => {
  const currRatio = 600 / currCanvas.height

  const width = (currCanvas.width * currRatio).toFixed(2)
  const height = (currCanvas.height * currRatio).toFixed(2)

  return {
    width, height, currRatio,
  }
}
